import { EXPEDIENTE_SOURCE_IDS } from "@tribunalea/shared";
import { ExpedienteDetailPage } from "../pages/ExpedienteDetailPage.jsx";

const sourceDetailPages = Object.freeze({
  [EXPEDIENTE_SOURCE_IDS.MENDOZA]: ExpedienteDetailPage,
  [EXPEDIENTE_SOURCE_IDS.NATIONAL]: ExpedienteDetailPage,
});

export function ExpedienteSourceDetailRoute({ expediente, routeKey }) {
  const DetailPage = sourceDetailPages[expediente.sourceId];
  if (!DetailPage) return null;
  return (
    <DetailPage
      key={`${routeKey}:${expediente.identifier}`}
      identifier={expediente.identifier}
      sourceId={expediente.sourceId}
    />
  );
}
